var _jsxFileName = "/home/runner/work/frontend-shared/frontend-shared/src/components/input/IconButton.tsx";
import classnames from 'classnames';
import { downcastRef } from '../../util/typing';
import ButtonBase from './ButtonBase';
import { inputGroupStyles } from './InputGroup';
import { jsxDEV as _jsxDEV } from "preact/jsx-dev-runtime";
/**
 * Render a button that only contains an icon.
 */
const IconButtonNext = function IconButton({
  children,
  classes,
  elementRef,
  pressed,
  expanded,
  icon: Icon,
  disableTouchSizing = false,
  size = 'md',
  title,
  variant = 'secondary',
  ...htmlAttributes
}) {
  return _jsxDEV(ButtonBase, {
    "data-component": "IconButton",
    ...htmlAttributes,
    classes: classnames('focus-visible-ring transition-colors whitespace-nowrap flex items-center', 'justify-center gap-x-2 rounded-sm', {
      // variant
      'text-grey-7 bg-transparent enabled:hover:text-grey-9 aria-pressed:text-brand aria-expanded:text-brand': variant === 'secondary',
      //default
      'text-brand bg-transparent enabled:hover:text-grey-9 disabled:text-grey-7': variant === 'primary',
      'text-grey-7 bg-grey-2 enabled:hover:text-grey-9 enabled:hover:bg-grey-3 disabled:text-grey-5 aria-pressed:bg-grey-3 aria-expanded:bg-grey-3': variant === 'dark',
      // size
      'p-2': size === 'md',
      // Default
      'p-1': size === 'xs',
      'p-1.5': size === 'sm',
      'p-2.5': size === 'lg',
      // Responsive
      'touch:min-w-touch-minimum touch:min-h-touch-minimum': !disableTouchSizing
    },
    // Adapt styling when this component is inside an InputGroup
    inputGroupStyles, classes),
    elementRef: downcastRef(elementRef),
    title: title,
    pressed: pressed,
    expanded: expanded,
    unstyled: true,
    children: [Icon && _jsxDEV(Icon, {
      className: "w-em h-em"
    }, void 0, false, {
      fileName: _jsxFileName,
      lineNumber: 85,
      columnNumber: 16
    }, this), children]
  }, void 0, true, {
    fileName: _jsxFileName,
    lineNumber: 50,
    columnNumber: 5
  }, this);
};
export default IconButtonNext;
//# sourceMappingURL=IconButton.js.map